const VisitorApprovalRequest = {

    // PAGE HEADER
    "visitor_approval_requests": "Visitor Approval Requests",

    // FIELDS
    "search": "Search",

    // TABLE HEADERS
    "table_photo": "PHOTO",
    "table_visitor": "VISITOR",
    "table_mobile": "MOBILE",
    "table_unit": "UNIT",
    "table_purpose": "PURPOSE",
    "table_status": "STATUS",

    // BUTTONS
    "approve": "Approve",
    "reject": "Reject",
    "confirm_approve_title": "Approve Request?",
    "confirm_approve_text": "This visitor approval request will be marked as approved.",
    "confirm_reject_title": "Reject Request?",
    "confirm_reject_text": "This visitor approval request will be marked as rejected.",
    "approved_success": "Request Approved.",
    "rejected_success": "Request Rejected.",
}

export default VisitorApprovalRequest;